export const LOCALIZATION_KEY = 'builder.resume_distribution.version_3'
export const LOCALIZATION_KEY_VER_4 = 'builder.resume_distribution.version_4'
